import { render } from "./UserTeams.vue?vue&type=template&id=18284952"
import script from "./UserTeams.vue?vue&type=script&lang=js"
export * from "./UserTeams.vue?vue&type=script&lang=js"

import "./UserTeams.vue?vue&type=style&index=0&id=18284952&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__